import { useTranslate } from 'ra-core'

const AdPlacementTitle = ({ record }: { record?: { code?: string } }) => {
  const translate = useTranslate()
  return (
    <span>
      {translate('Ad Placement')} - {record && record.code ? `"${record.code}"` : ''}
    </span>
  )
}

export default {
  list: { lazy: () => import('./AdPlacementList') },
  edit: { lazy: () => import('./AdPlacementEdit') },
  create: { lazy: () => import('./AdPlacementCreate') },
  options: {
    create: {
      title: 'Create Ad Placement',
      subtitle: null,
      breadCrumb: 'Create Ad Placement',
    },
    list: {
      title: 'Ad Placements',
      subtitle: null,
      breadCrumb: 'Ad Placements',
    },
    edit: {
      title: <AdPlacementTitle />,
      subtitle: null,
      breadCrumb: 'Edit Ad Placement',
    },
  },
}
